export default "__VITE_ASSET__CS7crzAg__"